const KEY = 'lynciaTherapy';

function validEntry(entry) {
  return entry && entry.version === 1 && ['voice', 'video'].includes(entry.mode)
    && typeof entry.accountId === 'string' && entry.accountId.length > 0 && entry.accountId.length <= 128
    && typeof entry.modelId === 'string' && entry.modelId.length > 0 && entry.modelId.length <= 256
    && typeof entry.courseId === 'string' && /^[A-Za-z0-9_-]{1,128}$/.test(entry.courseId);
}

// This tab's history entry holds navigation identity, never credentials or turns.
export function readTherapyNavigation(state, hash, accountId) {
  if (!['#voice', '#video'].includes(hash) || !state || !Object.hasOwn(state, KEY)) return null;
  const entry = state[KEY];
  if (!validEntry(entry) || entry.accountId !== accountId || hash !== `#${entry.mode}`) return { status: 'invalid' };
  return { status: 'valid', mode: entry.mode, courseId: entry.courseId, modelId: entry.modelId };
}

export function writeTherapyNavigation(state, identity) {
  const next = state && typeof state === 'object' && !Array.isArray(state) ? { ...state } : {};
  const entry = { version: 1, accountId: identity.accountId, modelId: identity.modelId,
    courseId: identity.courseId, mode: identity.mode };
  if (validEntry(entry)) next[KEY] = entry;
  else delete next[KEY];
  return Object.keys(next).length ? next : null;
}

export function restoredTherapyModel(navigation, models) {
  if (navigation?.status !== 'valid') return null;
  return models.find(model => model.id === navigation.modelId && model.course_capable
    && (navigation.mode !== 'video' || (model.video !== false && !model.voice_only))) || null;
}
